<template>
    <!-- Featured Images Section -->
    <div class="feature-images-section-wrapper">
        <div class="feature-images-container" :class="{ 'single-column': getStaticScenes.length === 1 }"
            :style="!isExpanded ? 'max-height:640px' : ''">
            <div class="feature-image-wrapper" v-for="(roomScene, index) in getStaticScenes" :key="roomScene">
                <wf-load-image :wrapper-class="'feature-image-wrapper'" :image-class="'pc-feature-images'" :src="roomScene"
                    :alt="'feature-image'" />
                <div class="descriptor-container">
                    <div class="descriptor-border-box">
                        <div class="descriptor-content-container">
                            <span class="descriptor-text">STYLE:</span> {{ sellingStyleNumber }}
                        </div>
                        <div class="descriptor-content-container">
                            <span class="descriptor-text">COLOR:</span>
                            <a class="descriptor-link" @click="getStaticColors(parsedColorNumbers, index)">
                                {{ getColorDescription(roomScene) }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showMoreFeatureImages" class="more-feature-images-container text-center">
            <a class="btn btn-white border-dark" @click="toggleExpanded" target="_self">
                {{ isExpanded ? 'VIEW LESS' : 'VIEW MORE' }}
            </a>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import WFLoadImage from "../wf-load-image.vue";

export default {
    data() {
        return {
            isExpanded: false,
            staticScenes: [],
            parsedGuids: [],
            parsedColorNumbers: [],
        };
    },
    computed: {
        ...mapGetters({
            roomScenes: "productDetail/roomScenes",
            productData: "productDetail/productData",
            sellingStyleNumber: "productDetail/sellingStyleNumber",
            selectedColor: "productDetail/color",
        }),
        getStaticScenes() {
            if (this.productData) {
                const staticScenes = this.productData.colors.flatMap(color => color.roomScenes);
                this.staticScenes = staticScenes.filter((staticUrl, index) => {
                    if (staticUrl === null) {
                        return false;
                    }
                    const matchGuid = staticUrl.match(/\/content\/([^/]+)\//);
                    if (!matchGuid) {
                        return false;
                    }
                    const uniqueGuid = matchGuid[1];

                    const matchColorNumber = staticUrl.match(/(\d{5})\.jpg/);
                    if (!matchColorNumber) {
                        return false;
                    }
                    const uniqueColorNumber = matchColorNumber[1];

                    if (this.parsedGuids.includes(uniqueGuid) || this.parsedColorNumbers.includes(uniqueColorNumber)) {
                        return false;
                    }

                    this.parsedGuids.push(uniqueGuid);
                    this.parsedColorNumbers.push(uniqueColorNumber);

                    const firstIndex = staticScenes.findIndex(url => url.includes(uniqueGuid) && url.includes(uniqueColorNumber));
                    return index === firstIndex;
                });
                return this.staticScenes;
            }
            return [];
        },
        showMoreFeatureImages() {
            return this.staticScenes.length > 2 || (this.staticScenes.length > 1 && window.innerWidth < 1096);
        }
    },
    methods: {
        ...mapActions({
            setColor: "productDetail/setColor",
        }),
        toggleExpanded() {
            this.isExpanded = !this.isExpanded;
        },
        getColorDescription(roomScene) {
            const match = roomScene.match(/([0-9]{5})\.jpg/);
            if (match) {
                const colorNumber = match[1];
                const color = this.productData.colors.find((color) => color.colorNumber === colorNumber);
                if (color) {
                    return `${colorNumber} ${color.colorName}`;
                }
            }
            return "";
        },
        getStaticColors(parsedColorNumbers, index) {
            if (
                parsedColorNumbers &&
                Array.isArray(parsedColorNumbers) &&
                parsedColorNumbers.length > index &&
                parsedColorNumbers[index] !== undefined
            ) {
                const colorNumber = parsedColorNumbers[index];
                const colorObject = this.productData.colors.find(
                    (color) => color.colorNumber === colorNumber
                );
                if (colorObject) { this.updateColor(colorObject); }
            }
        },
        updateColor: function (color) {
            this.setColor(color);
            // this.visibleThreeDButton();
            let url = new URL(window.location);
            // Replace URL path to include updated color
            window.history.replaceState(null, null,
                `/product/detail/${this.productData.styleNameURL}-${this.sellingStyleNumber}/${color.colorNumber}${url.searchParams ? "?" + url.searchParams.toString() : null}`
            );
        },
    },
    components: {
        "wf-load-image": WFLoadImage,
    },
};
</script>
  
<style></style>